export default __webpack_public_path__ + "static/media/615.0f7d9489.gif";